export const hasPropertyValue =
  <T extends Record<P, unknown>, P extends keyof T>(property: P, value: T[P] | undefined) =>
  (record: T): boolean =>
    Object.is(record[property], value)
